module.exports = __webpack_public_path__ + "static/img/vasi.efe9ee3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/vasi.png
// module id = 460
// module chunks = 1